import type { Dispatch, SetStateAction } from 'react'
import { createContext, use, useMemo, useState } from 'react'

interface CartContextType {
  isDrawerOpen: boolean
  setIsDrawerOpen: Dispatch<SetStateAction<boolean>>
}

const CartContext = createContext<CartContextType | null>(null)

export const useCartContext = () => {
  const context = use(CartContext)

  if (!context) {
    throw new Error('useCartContext must be used within a CartProvider')
  }

  return context
}

export const useOptionalCartContext = () => {
  const context = use(CartContext)

  if (!context) {
    return null
  }

  return context
}

interface CartProviderProps {
  children: React.ReactNode
}

export const CartContextProvider = ({ children }: CartProviderProps) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)

  const context = useMemo(
    () => ({
      isDrawerOpen,
      setIsDrawerOpen,
    }),
    [isDrawerOpen]
  )

  return <CartContext.Provider value={context}>{children}</CartContext.Provider>
}
